// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.message[data-v-6a1a22d8] {\n  padding: 30px 30px;\n}\n", ""]);
// Exports
module.exports = exports;
